export const imageBaseUrl = process.env.REACT_APP_S3_BUCKET_BASE_URL;
